/* This is updated by the Jenkins script to reflect
   the value of the sha commit
   @see JenkinsFile
 */
export const commit_sha : string = 'PHEWEB VERSION : 36a698114a40aa841cf95078694c3371a4a4328b';
